import { render, staticRenderFns } from "./menu-item.vue?vue&type=template&id=07cd676c&scoped=true&"
import script from "./menu-item.vue?vue&type=script&lang=js&"
export * from "./menu-item.vue?vue&type=script&lang=js&"
import style0 from "./menu-item.vue?vue&type=style&index=0&id=07cd676c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07cd676c",
  null
  
)

export default component.exports